import { render, staticRenderFns } from "./drawer-user-edit.vue?vue&type=template&id=5afdeb49&"
import script from "./drawer-user-edit.vue?vue&type=script&lang=js&"
export * from "./drawer-user-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports